import React, { useState, useEffect } from 'react';

const Avatar = ({ className = "avatar-button", style = { color: "#cfcfcf" }, onClick, children }) => {
  const [userAvatar, setUserAvatar] = useState(null);

  const fetchUserAvatar = async () => {
    try {
      const response = await fetch('/api/employee/avatar', {
        method: 'GET',
        credentials: 'include',
      });
  
      if (!response.ok) throw new Error('Erreur lors de la récupération de l\'avatar');
  
      const data = await response.json();
      setUserAvatar(data.avatar);
    } catch (error) {
      console.error('Erreur avatar:', error);
    }
  };

  useEffect(() => {
    fetchUserAvatar();
  }, []);

  return (
    <button 
      id="avatarButton"
      className={`${className} ${!userAvatar ? 'fa-solid fa-user' : ''}`}
      style={style}
      onClick={onClick}
    >
      {userAvatar && (
        <img 
          src={userAvatar} 
          alt="Avatar utilisateur"
          style={{ 
            width: '100%', 
            height: '100%', 
            borderRadius: '50%', 
            objectFit: 'cover' 
          }} 
        />
      )}
      {children}
    </button>
  );
};

export default Avatar;
